import { createReducer } from 'redux-create-reducer'

import {
  TRACK_SHARE_SUCCESS,
  TRACK_SHARES_LOADING_SUCCESS,
} from '@disco/constants/ActionTypes'

import { normalize } from './playlistShares'

const initialState = {}

export type TrackSharesState = typeof initialState

export const trackSharesReducer = createReducer<TrackSharesState, any>(
  initialState,
  {
    [TRACK_SHARE_SUCCESS](state, action) {
      const { id } = action.result
      const update = {
        [id]: {
          ...(state[id] || {}),
          ...normalize(action.result),
        },
      }
      return { ...state, ...update }
    },

    [TRACK_SHARES_LOADING_SUCCESS](state, { responseShares }) {
      const update = {}
      responseShares.forEach(item => (update[item.id] = normalize(item)))
      return { ...state, ...update }
    },
  },
)
